import { PropsWithChildren, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { acquireBodyScrollLock } from "../../utils/lockBodyScroll";

export const ModalPortal = ({ children }: PropsWithChildren) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return acquireBodyScrollLock();
  }, []);

  if (!mounted) {
    return null;
  }

  return createPortal(children, document.body);
};
